import getDay from '@teetsh/app/src/utils/time/getDay';
import setDay from '@teetsh/app/src/utils/time/setDay';

export function getDateForDayView(
  date: Date,
  workingDays: number[],
  today: Date,
): Date {
  const sundayStart = workingDays.includes(-1);
  const normalizedWorkingDays = workingDays.map(w => (w + 1) % 7);
  if (normalizedWorkingDays.includes(getDay(today))) {
    return setDay(date, getDay(today), sundayStart);
  }
  return normalizedWorkingDays.includes(getDay(today)) ? date : date;
}
